import { createRoutine } from 'redux-saga-routines'

export const SET = 'REGISTER_LAYOUT/SET'
export const CONTENT = createRoutine('REGISTER_LAYOUT/CONTENT')
